/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  ListVariantsCatalogQueryResponse,
  ListVariantsCatalogQueryParams,
} from '../../types/ListVariantsCatalog'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listVariantsCatalog } from '../../clients/listVariantsCatalog'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listVariantsCatalogQueryKey = (
  params?: ListVariantsCatalogQueryParams
) =>
  [
    { url: '/api/v1/products/catalog/variants/' },
    ...(params ? [params] : []),
  ] as const

export type ListVariantsCatalogQueryKey = ReturnType<
  typeof listVariantsCatalogQueryKey
>

export function listVariantsCatalogQueryOptions(
  params?: ListVariantsCatalogQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listVariantsCatalogQueryKey(params)
  return queryOptions<
    ListVariantsCatalogQueryResponse,
    ResponseErrorConfig<Error>,
    ListVariantsCatalogQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listVariantsCatalog(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @description Get paginated variants catalog.
 * GET /variants/
 * Query Parameters:
 * - search: Search by SKU, name, UPC/GTIN, or product name
 * - match_status: Filter by status (matched, unmatched, ignored, all)
 * - product: Filter by product ID (list, supports -1 for unmatched)
 * - type: Filter type for multi-select logic (one, all, neither)
 * - sort/ordering: Field to sort by (with optional - prefix for descending)
 * - page: Page number (default: 1)
 * - limit/page_size: Items per page (default: 50, max: 1000)
 * Date Range Filters (use _greater/_less suffixes):
 * - created_greater/less: Filter by creation date
 * - modified_greater/less: Filter by modification date
 * Returns:
 * {
 * "results": [...],
 * "count": total_count,
 * "page": page,
 * "page_size": page_size,
 * "unmatched_count": unmatched_count
 * }
 * @summary List variants catalog
 * {@link /api/v1/products/catalog/variants/}
 */
export function useListVariantsCatalog<
  TData = ListVariantsCatalogQueryResponse,
  TQueryData = ListVariantsCatalogQueryResponse,
  TQueryKey extends QueryKey = ListVariantsCatalogQueryKey,
>(
  params?: ListVariantsCatalogQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListVariantsCatalogQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? listVariantsCatalogQueryKey(params)

  const query = useQuery(
    {
      ...listVariantsCatalogQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
